import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css']
})
export class RatingComponent implements OnInit {
  currentRating: number = 5;
  constructor() { }

  ngOnInit() {
  }

  onRatingChange(newRating: number) {
    this.currentRating = newRating;
    console.log('New Rating:', newRating);
  }

}
